module.exports = __webpack_public_path__ + "static/media/store_week_am.70be5999.svg";